(function() { window.GUID_543857d7_bb57_49ac_b2c2_444eaf6e6477 = { getGuid: function() { return "543857d7-bb57-49ac-b2c2-444eaf6e6477"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class popupwizard_sportevent_fees_start extends Controls.PopupWizardStep {
            constructor() {
                super(...arguments);
                this.NextStep = "select-fees";
            }
            OnCheckIfCanContinue() {
                let checked = this.$StepDiv.find("input:checked");
                return checked.length !== 0;
            }
            OnSubmit() {
                let ids = this.$StepDiv.find("input[name^='player_']:checked").map((i, e) => { return e.name.split('_').pop().split('.'); }).get();
                let $PlayerIds = this.$StepDiv.find("#PlayerIds");
                $PlayerIds.val(ids.join(','));
            }
            OnLoad() {
                let me = this;
                let checkbox = $("#checkbox-payforother");
                if (checkbox.hasClass('checked')) {
                    $(".payForOthers").show();
                }
                else {
                    $(".payForOthers").hide();
                }
                // alert(checkbox.val());
                CS.Controls.CheckBox.Events.CheckboxValueChanged({
                    selector: "#checkbox-payforother",
                    callback: (checkbox, e) => {
                        if (checkbox.IsChecked) {
                            $(".payForOthers").show();
                        }
                        else {
                            $(".payForOthers").hide();
                        }
                    }
                });
            }
        }
        Controls.popupwizard_sportevent_fees_start = popupwizard_sportevent_fees_start;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=start.js.map
